import { render, staticRenderFns } from "./parcel_non_fragile.vue?vue&type=template&id=1136e623"
import script from "./parcel_non_fragile.vue?vue&type=script&lang=js"
export * from "./parcel_non_fragile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports